// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ny5Y","col":"styles_col__3Oqts"};